<template>
  <div class="btn-wrapper">
    <button
      class="btn-wrapper__buy-btn buy-btn"
      :class="[
        size ? 'buy-btn--' + size : '',
        type ? 'buy-btn--' + type : '',
        classes,
        { 'buy-btn--invert buy-btn--pre-order': preOrderBtn },
        { 'is-product-page': productPage, 'is-small-card': smallCard }
      ]"
      type="button"
      @click="handleButton"
      :ref="oneClickBtn ? 'oneClickBtn' : ''"
      :disabled="isLoading"
    >
      <span
        v-if="!preOrderBtn && !oneClickBtn"
        class="add-to-cart__svg-wrap">
        <svg
          class="buy-btn__svg"
          width="20"
          height="21"
          fill="none">
          <use
            v-if="storeId || (!storeId && availableInStore)"
            :xlink:href="spritePath + '#buy-store'"></use>
          <use
            v-else
            :xlink:href="spritePath + '#buy-cart'"></use>
        </svg>
        <svg
          v-if="isProductInCart"
          class="add-to-cart__checkmark"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="6.5"
            cy="6.5"
            r="6"
            fill="#52D04F"
            stroke="white" />
          <rect
            x="2.6001"
            y="6.65743"
            width="1.3"
            height="3.9"
            transform="rotate(-45 2.6001 6.65743)"
            fill="white" />
          <rect
            x="9.03467"
            y="3.90001"
            width="1.3"
            height="6.5"
            transform="rotate(45 9.03467 3.90001)"
            fill="white" />
        </svg>
      </span>
      <span
        v-if="preOrderBtn"
        class="add-to-cart__svg-wrap add-to-cart__svg-wrap--preorder"
      >
        <svg class="buy-btn__svg"
             width="24"
             height="24"
             viewBox="0 0 24 24"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M4.74781 7.64515L4.41783 11.275L4.41685 11.2858C4.36762 11.8273 4.34286 12.0996 4.38784 12.3583C4.42796 12.5891 4.50796 12.8111 4.62486 13.014C4.75604 13.2418 4.94984 13.4356 5.33494 13.8207L5.34166 13.8274L10.5044 18.9901L10.5091 18.9948C11.298 19.7837 11.6927 20.1785 12.1485 20.3265C12.5502 20.4571 12.9829 20.4571 13.3846 20.3265C13.8413 20.1782 14.2381 19.7821 15.0301 18.9901L18.9899 15.0303C19.782 14.2382 20.1772 13.8423 20.3255 13.3856C20.4561 12.9839 20.4561 12.5513 20.3255 12.1496C20.1772 11.6929 19.7818 11.2969 18.9897 10.5049L13.827 5.34217C13.4374 4.95261 13.2426 4.7578 13.0135 4.62586C12.8106 4.50896 12.5885 4.4286 12.3577 4.38848C12.0973 4.34319 11.8229 4.3681 11.2742 4.41798L7.64439 4.74796C6.70023 4.8338 6.22684 4.87683 5.85728 5.08234C5.53136 5.26358 5.26258 5.53236 5.08133 5.85829C4.87682 6.22607 4.83414 6.69556 4.74913 7.63069L4.74781 7.64515Z"
                stroke="#333333"
                stroke-width="2"
                fill="transparent"
                stroke-linecap="round"
                stroke-linejoin="round"/>
          <circle cx="9"
                  cy="9"
                  r="2"
                  fill="#333333"/>
        </svg>
      </span>
      <span
        id="one-click-btn"
        v-if="oneClickBtn">{{ $t('quick_order') }}</span>
      <span v-else-if="preOrderBtn">{{ $t('pre_order') }}</span>
      <span v-else-if="!(type === 'icon-only')">{{
        isProductInCart
          ? $t('cart.count.text')
          : btnText
            ? btnText
            : $t('buy_button')
      }}</span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { spritePath } from '@/mixins/spritePath'
import { formattedDeliveryInfo } from '@/mixins'
import { GoogleTagManagerService, RtbHouseService, GoogleEnhancedEcommerce } from '@/services/AnalyticService'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
export default {
  name: 'BuyBtn',
  mixins: [spritePath, formattedDeliveryInfo],
  props: {
    availableInStore: {
      type: [Boolean, Object]
    },
    storesData: {
      type: [Array, Boolean]
    },
    btnText: String,
    analyticsData: Array,
    productId: Number,
    code: String,
    price: Number,
    priceOld: [Number, String],
    classes: String,
    preOrderBtn: {
      type: Boolean,
      default: false
    },
    oneClickBtn: {
      type: Boolean,
      default: false
    },
    productPage: {
      type: Boolean,
      default: false
    },
    smallCard: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    titleAnalytics: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    },
    storeId: {
      type: [String, Number],
      default: ''
    },
    esputnikData: Object,
    esputnikBlockId: String,
    productLink: String,
    withoutHandler: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isManager', 'cartModalName']),
    ...mapState({
      user: state => state.user,
      productsInCartIds: state => state.cart.cartSort,
      cartProducts: state => state.cart.products,
      formData: state => state.checkout.formData,
      storesInCity: state => state.geoLocation.storesInCity,
      userStore: state => state.geoLocation.userStore
    }),
    productData () {
      return {
        imageUrl: this.photo,
        name: this.title,
        price: this.price,
        price_old: this.priceOld,
        currency: CurrencyFormatter('').trim(),
        id: this.productId,
        code: this.code,
        itemQuantity: this.preOrderBtn ? 1 : 0,
        productUrl: this.productLink
      }
    },
    storeUidForCheckout () {
      return this.formData?.deliveryType?.methodId === 1 &&
      this.formData?.deliveryInfo?.deliverySpot?.uid
        ? this.formData.deliveryInfo.deliverySpot.uid
        : null
    },
    isProductInCart () {
      return this.productsInCartIds.includes(this.productId)
    },
    currentProductFromCart () {
      return this.cartProducts.find(el => el.id === this.productId)
    },
    esputnikLink () {
      return this.esputnikBlockId ? window.location.protocol + '//' + window.location.hostname + this.productLink : ''
    }
  },
  methods: {
    CurrencyFormatter,
    ...mapActions(['REMOVE_PRODUCT_FROM_CART']),
    handleButton () {
      if (this.withoutHandler) return this.$emit('click')
      const userStoreId = this.userStore?.id
      const hasQuantityOnSelectedStore = this.storesData && this.storesData.find(el => el.id === userStoreId && +el.quantity > 0)
      if (!hasQuantityOnSelectedStore && this.availableInStore && !this.isProductInCart) {
        const storesWithQuantity = this.storesInCity.map(el => {
          const sameStoreWithQuantity = this.storesData.find(el2 => +el2.id === +el.id)
          return {
            ...el,
            quantity: sameStoreWithQuantity ? +sameStoreWithQuantity.quantity : 0
          }
        })
        this.$modal.show('map-modal', {
          spots: this.formatDeliverySpotsInfo(storesWithQuantity, 'chooseStore'),
          mailName: 'chooseStore',
          productId: this.productId,
          title: this.$t('reserve_map_title')
        })
        return
      }

      this.preOrderBtn ? this.preOrder() : this.oneClickBtn ? this.buyOneClick() : this.isProductInCart ? this.showCartModal() : this.addToCart()
    },
    addToCart () {
      this.isLoading = true

      this.$store
        .dispatch('ADD_PRODUCT_TO_CART', {
          productId: this.productId,
          storeId: this.storeId,
          storeUid: this.storeUidForCheckout,
          deliveryType: this.formData.deliveryType ? this.formData.deliveryType.methodId : null,
          esputnikData: this.esputnikData,
          esputnikBlockId: this.esputnikLink
        })
        .then(
          response => {
            this.showCartModal()
            this.$store.dispatch('CHANGE_CART_RTB_HOUSE_CODE_FLAG', true)

            const currentProduct = response.products.find(product => product.id === this.productId)

            RtbHouseService.ShoppingCartAddToCartCode(this.productId.toString())
            if (GoogleEnhancedEcommerce.isEnabled) {
              GoogleEnhancedEcommerce.addToCart({
                value: +GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).price * parseInt(GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0]).quantity),
                items: [GoogleEnhancedEcommerce.getGoogleEnhancedEcommerceData(currentProduct.analytics_data[0])]
              })
            } else {
              GoogleTagManagerService.pushToAnalytics({
                analyticsData: currentProduct.analytics_data,
                eventName: 'add_to_cart'
              })
            }

            // GoogleTagManagerService.addToCartEvent({
            //   analyticsData: currentProduct.analytics_data,
            //   params: {
            //     'event': 'gtm-ee-event-add-to-cart',
            //     'gtm-ee-event-action': 'Adding a Product to a Shopping Cart'
            //   }
            // })

            // window.gtag('event', 'add_to_cart', {
            //   'ecomm_pagetype': window.ecomm_pagetype || 'other',
            //   'ecomm_prodid': this.code,
            //   'ecomm_totalvalue': this.price
            // })

            window.fbq('track', 'AddToCart', {
              content_name: this.titleAnalytics,
              content_ids: [this.code],
              content_type: 'product',
              value: this.price,
              currency: window.config?.currency?.currency_code
            })
          },
          () => {
            this.$modal.show('warning-modal', {
              text: this.$t('product_ends_warning_text'),
              title: this.$t('product_ends_warning_title')
            })
          }
        )
        .finally(() => {
          this.isLoading = false
        })
    },
    preOrder () {
      this.$modal.show('quick-order-modal', { type: 'pre-order', productsData: [this.productData] })
    },
    buyOneClick () {
      this.$modal.show('quick-order-modal', { type: 'one-click' })
    },
    showCartModal () {
      this.$modal.show(this.cartModalName)
      this.$modal.hide('photo-modal')
    },
    notifyError (message) {
      this.$notify({
        group: 'error',
        title: this.$t('error'),
        text: message,
        type: 'error'
      })
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style lang="sass" scoped>

.btn-wrapper
  position: relative

.buy-btn
  display: flex
  align-items: center
  padding: 6px 36px
  max-height: 40px
  background-color: $main-color
  border: 1px solid $main-color
  border-radius: 3px
  color: $white-text-color
  font-weight: 500
  font-size: 14px
  line-height: normal
  transition: .1s ease-in-out background-color, .1s ease-in-out color

  &:hover,
  &:focus
    background-color: $main-color--hover

    .add-to-cart__svg-wrap--preorder
      svg
        circle
          fill: #fff
        path
          stroke: #fff

  &[disabled]:not(.buy-btn--invert):not(.buy-btn--icon-only)
    background-color: lighten($main-color, 10%)

.buy-btn--invert
  color: $text-color
  background-color: $page-bg

  &:hover,
  &:focus
    color: $white-text-color
    background-color: $main-color

.buy-btn--pre-order
  padding: 6px 30px

.buy-btn--medium
  padding: 10px 20px

  +mmin($extsmall--hor)
    padding: 10px 31px

.buy-btn--small
  padding: 6px 22px 7px
  font-size: 12px
  font-weight: 400
  line-height: inherit

  .buy-btn__svg
    width: 14px
    height: 14px

.buy-btn--icon-only
  // border-radius: 2.5px
  padding: 0

  .add-to-cart__svg-wrap
    margin-right: 0

  .buy-btn__svg
    width: 20px
    height: 21px
    margin-right: 0

  .add-to-cart__checkmark
    display: block

.buy-btn__svg
  fill: $white-text-color
  transition: .1s ease-in-out fill

.product-card:not(.product-card--not--adaptive) .product-card__buy-btn .buy-btn
  +mmax(768)
    font-size: 12px
    line-height: 14px
    padding: 6px 10px

  .add-to-cart__svg-wrap
    margin-right: 8px

  .buy-btn__svg
    width: 16px
    height: 16px

.cart-product-card__add-to-cart .buy-btn
  font-size: 12px
  line-height: 14px
  font-weight: 400
  background-color: transparent
  padding: 2px 5px
  color: $text-color

  .buy-btn__svg
    width: 22px
    height: 22px
    fill: $main-color

  .add-to-cart__checkmark
    display: block

.product-card-comparison .add-to-cart__checkmark
  display: block

.product-card:not(.product-card--not--adaptive) .product-card__buy-btn--pre-order,
.product-card:not(.product-card--not--adaptive) .product-card__buy-btn--novelty
  +mmax(768)
    display: none

.product-card:not(.product-card--not--adaptive) .product-card__buy-btn .buy-btn--pre-order
  +mmax(768)
    display: none

.product-card__buy-btn .buy-btn__response-message
  +mmax(768)
    display: none

.add-to-cart__svg-wrap
  display: flex
  align-items: center
  position: relative
  margin-right: 15px

.add-to-cart__checkmark
  position: absolute
  bottom: 1px
  right: -4px
  display: none

.is-product-page
  width: 100%
  justify-content: center

  +mmin($large--mid)
    width: auto

.is-product-page.is-small-card
  width: 100%

.product-sets-footer__buy-btn .buy-btn
  width: 100%
  justify-content: center

  +mmin($tablet)
    width: auto

.product-actions__btn .buy-btn span
  flex-shrink: 0

.product-actions__btn .buy-btn
  +mmax(768)
    max-height: 100%
    padding: 15px 31px
</style>

<style lang="scss" scoped>
.add-to-cart__checkmark {
  bottom: 13px;
  right: -5px;
  width: 16px;
  height: 16px;
  border: 1px solid red;
  border-radius: 50%;

  circle {
    fill: white;
  }
  rect {
    fill: red;
  }
}
</style>
